// Phase 2D.2A — the SHAPE of the recovery landing URL.
//
// Only BOOLEANS are ever produced here. No access token, refresh token,
// authorization code, fragment, e-mail or provider error text is stored,
// exported or logged.
//
// The repository uses the Supabase implicit flow (createClient is configured
// with detectSessionInUrl and no flowType override, and @supabase/auth-js
// defaults to 'implicit'), so a genuine recovery link lands as
// ``#access_token=...&type=recovery`` and a dead link lands as
// ``#error=...&error_code=...``.
//
// ``RECOVERY_LINK`` is captured once at boot, before the Supabase client can
// strip the fragment. ``readRecoveryLinkState()`` re-reads the CURRENT address
// so a client-side navigation into the reset route is judged correctly too.
// Neither is ever enough to unlock the form: that takes the PASSWORD_RECOVERY
// event Supabase itself emits. The worst either can do is show a refusal or
// keep the screen waiting.

function readParams() {
  if (typeof window === "undefined" || !window.location) return new URLSearchParams();
  const fragment = String(window.location.hash || "").replace(/^#/, "");
  const query = String(window.location.search || "").replace(/^\?/, "");
  return new URLSearchParams([query, fragment].filter(Boolean).join("&"));
}

export function readRecoveryLinkState() {
  const params = readParams();
  const errorLabel = `${params.get("error_code") || ""} ${params.get("error") || ""}`;
  return {
    // A recovery-shaped address: the SDK is expected to establish a recovery
    // session from it and emit PASSWORD_RECOVERY.
    looksLikeRecovery:
      params.get("type") === "recovery" && Boolean(params.get("access_token")),
    // The provider refused the link (expired, already used, malformed).
    failed: Boolean(
      params.get("error") || params.get("error_code") || params.get("error_description"),
    ),
    // Boolean only — the provider's own wording is never kept or shown.
    expired: /expired/i.test(errorLabel),
  };
}

export const RECOVERY_LINK = Object.freeze(readRecoveryLinkState());
